import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* refundReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.REFUND_REPORT, action.payload, true);
}

export function* salesReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.SALES_REPORT, action.payload, true);
}

export function* timeCardsReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.TIME_CARDS_REPORT, action.payload, true);
}

export function* tipReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.TIP_REPORT, action.payload, true);
}

export function* inventoryMovementReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.INVENTORY_MOVEMENT_REPORT, action.payload, true);
}

export function* inventoryStockReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.INVENTORY_STOCK_REPORT, action.payload, true);
}

export function* transactionReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.TRANSACTION_REPORT, action.payload, true);
}

export function* commisionReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.COMMISSION_REPORT, action.payload, true);
}

export function* salesByLocation(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.SALES_BY_LOCATION, action.payload, true);
}

export function* salesByCategory(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.SALES_BY_CATEGORY, action.payload, true);
}

export function* salesByProductType(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.SALES_BY_PRODUCT_TYPE, action.payload, true);
}

export function* salesByProduct(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.SALES_BY_PRODUCT, action.payload, true);
}

export function* salesByVendor(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.SALES_BY_VENDOR, action.payload, true);
}

export function* salesByDiscount(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.SALES_BY_DISCOUNT, action.payload, true);
}

export function* voidTransaction(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.VOID_TRANSACTION, action.payload, true);
}

export function* poTerminals(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.PO_TERMINALS, action.payload, true);
}

export function* grossProfit(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.GROSS_PROFIT, action.payload, true);
}

export function* netSales(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.NET_SALES, action.payload, true);
}

export function* returns(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.RETURNS, action.payload, true);
}

export function* loyaltyProgram(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.LOYALTY_PROGRAM, action.payload, true);
}

export function* storeCredit(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.STORE_CREDIT, action.payload, true);
}

export function* cogs(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.COGS, action.payload, true);
}

export function* tax(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.TAX, action.payload, true);
}

export function* inventorySummary(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.INVENTORY_SUMMARY, action.payload, true);
}

export function* salesByCustomerGroup(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.SALES_BY_CUSTOMER_GROUP, action.payload, true);
}

export function* returnByVendor(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.RETURN_BY_VENDOR, action.payload, true);
}

export function* topSellingCategory(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.TOP_SELLING_CATEGORY, action.payload, true);
}

export function* stockAdjustmentReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.STOCK_ADJUSTMENT, action.payload, true);
}

export function* depositReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.DEPOSIT_REPORT, action.payload, true);
}

export function* cartDiscardedProduct(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.CART_DISCARDED_PRODUCT, action.payload, true);
}

export function* endOfDayReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.END_OF_DAY, action.payload, true);
}

export function* cashRegisterCloseReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.CASH_REGISTER_CLOSE, action.payload, true);
}

export function* batchCloseReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.BATCH_CLOSE_REPORT, action.payload, true);
}

export function* salesSummaryReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.SALES_SUMMARY, action.payload, true);
}

export function* cashDropReport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.REPORTING.CASH_DROP_REPORT, action.payload, true);
}